module.exports = __webpack_public_path__ + "img/9788952216199.617650a9.jpg";